@let showAllegedFather = fieldSet().includes(ServiceDataFields.AllegedFather);
@let showParticipants =
  fieldSet().includes(ServiceDataFields.AdditionalParticipants) &&
  paternityParticipants.length > 0;

@if (showAllegedFather || showParticipants) {
  <section
    *appRequirePermission="id() ? ['patientInformation'] : []"
    data-cy="AdditionalParticipants-section"
  >
    <p class="caption mb-1">
      {{ 'serviceData.form.participants.title' | translate }}
    </p>
    <hr class="mt-0" />
    @if (showAllegedFather) {
      <ng-container formGroupName="nippt">
        <ng-container formGroupName="allegedFather">
          <p class="label mb-2">
            {{ 'serviceData.form.participants.allegedFather' | translate }}
          </p>
          <app-service-data-form-participant
            idPrefix="allegedFather"
            [fields]="allegedFatherFields"
            [minAge]="5"
          />
        </ng-container>
      </ng-container>
    }
    @if (showParticipants) {
      <ng-container formGroupName="paternity">
        <ng-container formArrayName="additionalParticipants">
          @for (
            participant of paternityParticipants.controls;
            track participant;
            let i = $index
          ) {
            <ng-container [formGroupName]="i">
              <p class="label mb-2">
                {{
                  'serviceData.form.participants.participant'
                    | translate: { number: i + 1 }
                }}
              </p>
              <app-service-data-form-participant
                [idPrefix]="'participant' + (i + 1)"
                [fields]="paternityParticipantFields"
              />
            </ng-container>
          }
        </ng-container>
      </ng-container>
    }
  </section>
}
